function popup(e) {

	e.preventDefault();
	let id = this.dataset.popup;
	let popupBlock = document.getElementById(id);

	if (popupBlock) {
		if (popupBlock.classList.contains('no-visible')) {
    		popupBlock.classList.remove('no-visible');
    		//document.body.classList.add('overflow');
    		setTimeout(function () {
                popupBlock.classList.remove('hidden');
    		}, 20);
  		} else {
    		popupBlock.classList.add('hidden');  
    		//document.body.classList.remove('overflow');  
    		popupBlock.addEventListener('transitionend', function(e) {
                popupBlock.classList.add('no-visible');
	    	}, {
		    	capture: false,
		    	once: true,
		    	passive: false
	    	});
		}
		// if (id == 'video') {
		// 	let media = modal.querySelector('video');	
		// 	media.autoplay = true;
		// 	media.load();
		// }
		// if (this.dataset.stop) {
		// 	let media = modal.querySelector('video');
		// 	media.autoplay = false;
		// 	media.pause();
		// 	media.currentTime = 0;
		// }
	}

}


export default popup;